import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import ConfirmPrompt from '../General/ConfirmPrompt';

export const CIRCLE_PLACEMENT_KEYS = ['onboarding', 'app_home_wheel', 'onboarding_creators', 'snapshop_popular', 'web_home_circles'];

export const message = error => error?.response?.data?.error || error?.message || 'Could not complete this request. Please try again.';

export const confirmDiscard = (subheader, onConfirm) => {
  const previous = document.activeElement;
  confirmAlert({
    willUnmount: () => previous?.focus(),
    customUI: ({ onClose }) => (
      <ConfirmPrompt
        hideInput
        header='Discard changes?'
        subheader={subheader}
        cancelBtnDisplay='Keep editing'
        submitBtnDisplay='Discard changes'
        onCancel={onClose}
        onSubmit={() => {
          onClose();
          onConfirm();
        }}
      />
    )
  });
};

export const moveRows = (rows, selected, activeId, overId) => {
  if (!overId || activeId === overId || selected.includes(overId)) return rows;
  const moving = rows.filter(row => selected.includes(row.id));
  const remaining = rows.filter(row => !selected.includes(row.id));
  const down = rows.findIndex(row => row.id === activeId) < rows.findIndex(row => row.id === overId);
  const target = remaining.findIndex(row => row.id === overId);
  if (target < 0) return rows;
  remaining.splice(target + (down ? 1 : 0), 0, ...moving);
  return remaining;
};

export const moveMember = (members, activeId, overId) => {
  const from = members.findIndex(member => member.User_id === activeId);
  const to = members.findIndex(member => member.User_id === overId);
  if (from < 0 || to < 0 || from === to) return members;
  const next = [...members];
  next.splice(to, 0, ...next.splice(from, 1));
  return next;
};

export const withCircleAssignment = (rows, circle, included) => {
  const updated = rows.map(row => (row.circle.id === circle.id ? { ...row, circle } : row));
  if (!included) return updated.filter(row => row.circle.id !== circle.id);
  return updated.some(row => row.circle.id === circle.id) ? updated : [...updated, { id: circle.id, circle }];
};
